/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule commitLocalUpdate
 * 
 * @format
 */

'use strict';

function commitLocalUpdate(environment, updater) {
  environment.commitUpdate(updater);
}

module.exports = commitLocalUpdate;


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/commitLocalUpdate.js
// module id = 1671
// module chunks = 0